import { render } from "./WorkPermit.vue?vue&type=template&id=10a94324&scoped=true"
import script from "./WorkPermit.vue?vue&type=script&lang=js"
export * from "./WorkPermit.vue?vue&type=script&lang=js"

import "./WorkPermit.vue?vue&type=style&index=0&id=10a94324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a94324"]])

export default __exports__